import { UPDATE_USER_LOCATION, UserLocationActionTypes } from "./types";
import { UserLocation } from "../../models/User";

export const updateUserLocation = (
  payload: UserLocation
): UserLocationActionTypes => ({
  type: UPDATE_USER_LOCATION,
  payload
});
